import { ChevronDownIcon } from '@heroicons/react/24/outline';
import { useState, type ReactNode } from 'react';

interface ActionCategoryCardProps {
    title: string;
    defaultOpen?: boolean;
    children: ReactNode;
    headerExtra?: ReactNode;
}

/**
 * Collapsible category container for the patient overview "Actions" tab —
 * a dashboard-local recreation of files-viewer's ActionsTab category card.
 */
function ActionCategoryCard({
    title,
    defaultOpen = true,
    children,
    headerExtra
}: ActionCategoryCardProps) {
    const [isExpanded, setIsExpanded] = useState(defaultOpen);

    return (
        <div className="rounded-xl border border-gray-200 bg-white overflow-hidden">
            <button
                type="button"
                onClick={() => setIsExpanded((prev) => !prev)}
                className={`w-full flex items-center justify-between px-4 py-3 bg-gray-50 ${
                    isExpanded ? 'border-b border-gray-100' : ''
                }`}
            >
                <div className="flex items-center gap-2">
                    <h4 className="text-sm font-semibold text-gray-900">{title}</h4>
                    {headerExtra}
                </div>
                <ChevronDownIcon
                    className={`w-4 h-4 text-gray-400 transition-transform duration-300 ${
                        isExpanded ? 'rotate-180' : ''
                    }`}
                />
            </button>
            <div
                className={`grid transition-all duration-300 ease-out ${
                    isExpanded ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                }`}
            >
                <div className="overflow-hidden">
                    <div className="p-4 flex flex-wrap gap-3">{children}</div>
                </div>
            </div>
        </div>
    );
}

export { ActionCategoryCard };
